import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    return Math.floor(value);
  }

}



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/shared/round.pipe.ts